
























































import A from '@/utilities/alpha'
import SliceActions from './SliceActions.vue'
import ToucanToggle from './ToucanToggle.vue'
import TextResponses from '../TextResponses.vue'
import Transcription from './Transcription.vue'
import AudioPlayer from './AudioPlayer.vue'
import icoLookup from '@/utilities/ico-lookup'
import { assetDataType } from '@/utilities/shared-report-helpers.js'
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { getResponseIDs, filterResponses, getResponseCount } from '@/utilities/text-response-helpers.js'
import analytics from '@/analytics'
import { Button } from '@alpha/ink'

@Component({
  components: {
    SliceActions,
    TextResponses,
    Transcription,
    AudioPlayer,
    ToucanToggle,
    Button
  }
})
export default class AssetDisplay extends Vue {
  @Prop() asset!:any
  @Prop() editable!:any
  @Prop() qualNotable!:any
  @Prop() drop!:any

  edit:boolean = false
  filteredRIDs:any = {}
  activeSlice:any = ''
  toucanFilterIdx:any = -1
  filter:any = {
    keywords: [],
    logicOperator: 'OR',
    totalResponses: 0
  }

  originalTotalResponses:any = 0

  load:boolean = false
  toggleAll:boolean = true

  srcObj:any = this.generateSrcObj

  get realDataType ():any {
    return assetDataType(this.asset)
  }

  get csvImg ():any {
    return this.realDataType === 'Data' && this.asset.url ? icoLookup.data : false
  }

  get window () {
    return window
  }

  get sliceKeys ():any {
    if (this.asset.charts) {
      return Object.keys(this.asset.charts)
    } else if (this.asset.textResponses) {
      return Object.keys(this.asset.textResponses)
    }
    return false
  }

  get slices ():any {
    if (this.asset.charts) {
      return this.asset.charts
    } else if (this.asset.textResponses) {
      return this.asset.textResponses
    }
    return false
  }

  get analysis ():any {
    return this.asset.alphaAnalysis && this.asset.alphaAnalysis.trim()
  }

  get filters ():any {
    if ((this.realDataType !== 'TextSlice' && this.realDataType !== 'Text') || !this.srcObj || !this.srcObj.responses) return []

    let filters:any = []
    if (this.realDataType === 'Text') {
      filters = this.asset.responses.filters || filters
    } else if (this.asset.textResponses.original) {
      filters = this.asset.textResponses.original.responses.filters || filters // Default use original slice
    } else {
      const textSlices = Object.keys(this.asset.textResponses)
      filters = this.asset.textResponses[textSlices[0]].responses.filters || filters // default to first one if no original slice
    }
    return filters
  }

  get generateSrcObj () {
    let srcObj:any = {
      loading: '/img/loading.gif'
    }

    switch (assetDataType(this.asset)) {
      case 'Chart':
        srcObj.src = this.asset.url
        break
      case 'Audio':
        srcObj.src = this.asset.url
        break
      case 'Other':
        srcObj.src = this.asset.url + '?embed=true'
        break
      case 'Video':
        srcObj.src = this.getWistiaURL(this.asset)
        break
      case 'VizSlice':
        if (this.asset.charts) {
          if (this.asset.charts.original) {
            srcObj.src = this.asset.charts.original.url // Default use original chart
          } else {
            var chartSlices = Object.keys(this.asset.charts)
            srcObj.src = this.asset.charts[chartSlices[0]].url // default to first one if no original
          }
        }
        break
      case 'AudSlice':
        var keys = Object.keys(this.asset.charts)
        srcObj.src = this.asset.charts[keys[0]].url // use first chart in audience slice
        break
      case 'TextSlice':
        if (this.asset.textResponses.original) {
          srcObj.responses = this.asset.textResponses.original.responses // Default use original slice
        } else {
          var textSlices = Object.keys(this.asset.textResponses)
          srcObj.responses = this.asset.textResponses[textSlices[0]].responses // default to first one if no original slice
        }
        srcObj.responses.originalTotalResponses = getResponseCount(srcObj.responses, true)
        break
      case 'Text':
        srcObj.responses = this.asset.responses
        srcObj.responses.originalTotalResponses = getResponseCount(srcObj.responses, true)
        break
      default:
        srcObj = false
    }

    return srcObj
  }

  @Watch('toucanFilterIdx')
  onToucanFilterIdx () {
    this.updateFilter()
  }

  mounted () {
    this.$Lazyload.$on('error', function (err:any) {
      console.error(err)
    })
    if (this.sliceKeys.length > 0) this.activeSlice = this.sliceKeys[0]
    if (this.toucanFilterIdx >= 0) this.updateFilter()
    if (this.originalTotalResponses === 0 && this.srcObj.responses) {
      if (this.realDataType === 'Text') {
        this.originalTotalResponses = getResponseCount(this.asset.responses)
      } else if (this.realDataType === 'TextSlice') {
        this.originalTotalResponses = getResponseCount(this.asset.textResponses.original.responses)
      }
    }
  }

  getWistiaURL (asset:any):string {
    var assetSrc = asset.url.split('/').slice(-1)[0]
    return '//fast.wistia.net/embed/iframe/' + assetSrc
  }

  clickAsset () {
    this.$emit('click', this.asset)
  }

  updateFilter () {
    const filter = this.filters[this.toucanFilterIdx]
    const currentFilter = {
      keywords: [],
      logicOperator: 'OR',
      totalResponses: 0
    }
    if (this.toucanFilterIdx > -1 && filter) {
      currentFilter.keywords = filter.keywords
      currentFilter.logicOperator = filter.logicOperator
      currentFilter.totalResponses = filter.totalResponses
    }
    this.$set(this, 'filter', currentFilter)
    this.updateData({ slice: this.activeSlice })
  }

  updateType (obj:any) {
    this.asset.asset_type = obj.asset_type
    this.$forceUpdate()
  }

  updateURL (obj:any, sliceName:any) {
    this.srcObj = { ...this.srcObj, src: obj.url }

    if (this.asset?.textResponses &&
        sliceName in this.asset.textResponses &&
        this.asset.textResponses[sliceName].responses) {
      this.srcObj.responses = this.asset.textResponses[sliceName].responses
    }

    this.$emit('updateCurrentSlice', sliceName)
    // if next slice has a different asset type, update. ex -> from text response to term frequency chart
    if (obj.asset_type && this.asset.asset_type !== obj.asset_type) {
      this.updateType(obj)
    } else {
      // force to update the DOM, sometimes it doesn't switch the slice ... updateType does this internally
      this.$forceUpdate()
    }
  }

  updateData (obj:any) {
    if (typeof obj !== 'object') {
      console.error(`updateData expected object, received: ${typeof obj}`)
    }
    let responses:any = false
    var key = obj.slice
    if (key) this.activeSlice = key
    if (this.realDataType === 'Text') responses = A.clone(this.filterResponsesByRID(this.asset.responses))
    else {
      for (var sliceKey in this.asset.textResponses) {
        const asset = this.asset.textResponses[sliceKey]
        if (asset.responses) {
          const filteredResponses = A.clone(this.filterResponsesByRID(asset.responses))
          asset.responses = filteredResponses
          if (asset.lucidKey === key || this.activeSlice === sliceKey || asset.lucidKey === obj.lucidKey) {
            responses = filteredResponses
          }
        }
      }
    }
    responses = responses || this.srcObj.responses
    if (responses) {
      if (!responses.originalTotalResponses) responses.originalTotalResponses = this.originalTotalResponses
      if (this.filter.keywords.length > 0) responses = this.applyFilter(responses)
      this.$set(this.srcObj, 'responses', responses)
    }
  }

  applyFilter (responses:any):any { // necessary evils. manually update the filterd responses after updating responses to the right slice and filtering by RID
    const clonedResponses = responses
    if (this.filter.keywords.length > 0) {
      clonedResponses.answers = filterResponses(clonedResponses, this.filter.keywords, this.filter.logicOperator)
      clonedResponses.totalResponses = getResponseCount(clonedResponses)
      clonedResponses.type = 'filter'
    }
    return clonedResponses
  }

  loadVideo () {
    this.load = true
    analytics.track('Shared Report Load Video', {
      testId: this.drop.id,
      testType: this.drop.payload.testType
    })
  }

  filterResponsesByRID (responses:any):any {
    // takes in an array of answers or the children of a group of answers
    var showHideResponses = (answers:any) => {
      answers.forEach((answer:any) => {
        if (answer.type === 'group') {
          showHideResponses(answer.children)
        } else {
          if (Object.keys(this.filteredRIDs).includes(answer.rid)) answer.show = this.filteredRIDs[answer.rid]
        }
      })
    }
    if (responses && responses.answers) showHideResponses(responses.answers)
    return responses
  }

  registerrids ($event:any) {
    const rids = $event.rids
    rids.forEach((rid:any) => {
      this.filteredRIDs[rid] = $event.show
    })
    this.updateData($event)
  }

  toggleAllCheckboxes ($event:any) {
    // this.toggleAll = !this.toggleAll
    const responses = this.asset.responses || this.srcObj.responses
    const rids = $event.rids

    // to check if this was to toggle everything, we will flip the state
    if (getResponseIDs(responses).length === rids.length) this.toggleAll = $event.toggleAll
    this.filteredRIDs = rids.reduce((acc:any, id:any) => {
      acc[id] = $event.toggleAll
      return acc
    }, this.filteredRIDs)

    this.updateData($event)
  }

  selectFilter ($event:any) {
    this.toucanFilterIdx = $event.idx
  }
}
